$("body").on("click", ".read_more_less_btn", function () {
    const button = $(this);
    const metaContent = button.siblings(".metafield_content");
    const image = button.closest(".banner-image-with-text-block__inner").find(".banner-image-with-text-block__image img");

    const defaultMaxHeight = 600;

    function toggleMetaContent() {
        metaContent.slideToggle(200, function () {
            if (metaContent.is(':visible')) {
                button.find("span").text(window.theme.strings.showLess);
            } else {
                button.find("span").text(window.theme.strings.showMore);
            }
        });
    }

    if (metaContent.is(':visible')) {
        image.css('max-height', image.data('original-max-height'));
        toggleMetaContent();
    } else {
        const maxHeight = image[0].complete && image[0].naturalHeight !== 0 ?
            Math.min(image[0].naturalHeight, defaultMaxHeight) :
            defaultMaxHeight;

        image.animate({ 'max-height': maxHeight + 'px' }, 200, toggleMetaContent);
        image.data('original-max-height', image.css('max-height'));
    }
});